import { PayrollResult } from '../entities/payroll-result';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Injector, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class PayrollResultService extends BaseCrudService<PayrollResult> {

    public uri = '/api/payrollResult/';

    constructor(injector: Injector) {
        super(injector);
    }

    buildSentence(entity?: PayrollResult, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        if (entity.fiscalYear && entity.fiscalYear.id) {
            query = query.concat(
                `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
            );
        }
        if (entity.executingUnit && entity.executingUnit.id) {
            query = query.concat(
                `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
            );
        }
        if (entity.month && entity.month.id) {
            query = query.concat(
                `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
            );
        }
        if (entity.employeeType && entity.employeeType.id) {
            query = query.concat(
                `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
            );
        }

        if (entity.payrollType && entity.payrollType.id) {
            query = query.concat(
                `payrollType.id${QueryOperator.Equal}${entity.payrollType.id}${QueryOperator.Split}`
            );
        }

        if (entity.costCenter && entity.costCenter.id) {
            query = query.concat(
                `costCenter.id${QueryOperator.Equal}${entity.costCenter.id}${QueryOperator.Split}`
            );
        }

        if (entity.payrollType && entity.payrollType.id) {
            query = query.concat(
                `payrollType.id${QueryOperator.Equal}${entity.payrollType.id}${QueryOperator.Split}`
            );
        }

        if (entity.employee && entity.employee.id) {
            query = query.concat(
                `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
            );
        }

        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
    }
}




// WEBPACK FOOTER //
// ./src/app/core/services/payroll-result.service.ts